import { RoadContentRouter } from "../../routers/RoadContentRouter"
import { RoadMapRouter } from "../../routers/RoadMapRouter"
import { SidebarRouter } from "../../routers/SidebarRouter"

import * as Styled from "./RoadDesktopLayout.styled"

export function RoadDesktopLayout() {
    return (
        <Styled.Wrapper>
            <SidebarRouter />
            <RoadContentRouter />
            <Styled.Map>
                <RoadMapRouter />
            </Styled.Map>
        </Styled.Wrapper>
    )
}
